<tui-push *tuiPush="open" [type]="'Для чуть более удобного тестирования'" (close)="toggle(false)">
  <div class="helper-container">
    <div class="controls">
      <tui-textfield tuiChevron [tuiTextfieldCleaner]="false">
        <input tuiSelect [formControl]="rightsGroupControl" />
        <tui-data-list-wrapper *tuiTextfieldDropdown new [items]="rightGroups" />
      </tui-textfield>

      <tui-textfield [tuiTextfieldCleaner]="true">
        <input
          tuiInputNumber
          [formControl]="numberControl"
          [min]="0"
          [max]="33554430"
          placeholder="Число для конвертации"
        />
      </tui-textfield>
    </div>

    <tui-scrollbar>
      @if (powersInfo.length) {
        <div class="rights-list">
          @for (info of powersInfo; track info) {
            <div
              class="right-item"
              [tuiHint]="hasDependencies(info) ? getDependsHint(info.depends) : ''"
              [tuiHintShowDelay]="50"
              [tuiHintHideDelay]="0"
              [tuiHintDirection]="'left'"
            >
              <div class="right-main">
                <div class="right-value">{{ info.power }}</div>
                <div class="right-info">
                  <div class="right-title">{{ info.title }}</div>
                  <div class="right-key">{{ info.key }}</div>
                </div>
              </div>
            </div>
          }
        </div>
      }
    </tui-scrollbar>

    <div class="helper-footer">
      <label tuiLabel>
        <input tuiCheckbox type="checkbox" [formControl]="doNotShowControl" />
        Больше не показывать
      </label>
    </div>
  </div>
</tui-push>
